

module.exports = __webpack_require__.stylable.create(
    "Footer1433305804",
    {"classes":{"root":"Footer1433305804__root","benefits":"Footer1433305804__benefits","arrow":"Footer1433305804__arrow"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Footer1433305804",
    null
);
